import { render, staticRenderFns } from "./FloatingService.vue?vue&type=template&id=43fbfcea&scoped=true"
import script from "./FloatingService.vue?vue&type=script&lang=js"
export * from "./FloatingService.vue?vue&type=script&lang=js"
import style0 from "./FloatingService.vue?vue&type=style&index=0&id=43fbfcea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fbfcea",
  null
  
)

export default component.exports